import { checkIfBusinessIsActive, getWebDisplayDataForBusiness } from "./firebase-database";
import { getLogoImageUrl } from "./firebase-storage";

export const isBusinessActive = async (businessId) => {
    return await checkIfBusinessIsActive(businessId);
};

export const getBusinessDisplayData = async (businessId) => {
    return await getWebDisplayDataForBusiness(businessId);
};

export const getBusinessLogoImageUrl = async (businessId) => {
    return await getLogoImageUrl(businessId);
};

